import { notification } from 'antd';
import {
  createNumberingsInvoice,
  deleteNumberingsInvoice,
  getNumberingInvoiceId,
  listNumberingsInvoice,
  updateNumberingsInvoice,
} from './Numberings.service';
import { useServiceError } from '@/hooks';
import { GetNumberings, NumberingsRequest } from './Numberings.types';
import { useMutation, useQuery, useQueryClient } from 'react-query';

export function useNumberingsMutation() {
  const mutation = useMutation((obj: GetNumberings) =>
    listNumberingsInvoice(obj),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useCreateNumberings() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: NumberingsRequest) => createNumberingsInvoice(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'A série e numeração foram criadas.',
        });

        queryClient.invalidateQueries(['invoiceSettings/company']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useDeleteNumberings() {
  const queryClient = useQueryClient();

  const mutation = useMutation((id: number) => deleteNumberingsInvoice(id), {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'A série e a numeração foram deletadas',
      });

      queryClient.invalidateQueries(['invoiceSettings/company']);
    },
  });

  useServiceError(mutation.error);
  return mutation;
}

export function useUpdateNumberings() {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (obj: NumberingsRequest) => updateNumberingsInvoice(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'A série e a numeração foram editadas',
        });

        queryClient.invalidateQueries(['invoiceSettings/company']);
      },
    },
  );
  useServiceError(mutation.error);
  return mutation;
}

export function useGetNumberingId() {
  const mutation = useMutation((id: number) => getNumberingInvoiceId(id));
  useServiceError(mutation.error);
  return mutation;
}

export function useNumberingList(params: GetNumberings) {
  return useQuery(
    ['numbering-invoice', { ...params }],
    () => listNumberingsInvoice(params),
    {
      enabled: !!params.configNfcId || !!params.configNfeId,
    },
  );
}
